import React, {useContext} from "react";
import Context from "../../context/Message";
import Message from "./Message";

export default ({messages}) => {
    const {sortMessages, allowAnswer} = useContext(Context);

    messages = messages.sort(sortMessages);

    return (
        <ul>
            {messages.map(message => (
                <Message
                    key={message.id}
                    message={message}
                    allowAnswer={allowAnswer}
                />
            ))}
        </ul>
    );
};
